const BUNDLE_NAME = 'BUNDLE-ID';

export const getMintsoftBundleInfo = (item) => {
  const bundleNameValue = item?.OrderItemNameValues?.find(
    (nameValue) => String(nameValue?.Name || '').toUpperCase() === BUNDLE_NAME
  );

  const rawValue = String(bundleNameValue?.Value || '').trim();
  if (!rawValue) return null;

  const [bundleProductId, bundleQuantity, bundleInstanceId] = rawValue
    .split(';')
    .map((part) => part.trim());

  if (!bundleProductId) return null;

  return {
    bundleProductId,
    bundleQuantity: Number.parseInt(bundleQuantity, 10) || 1,
    bundleInstanceId: bundleInstanceId || rawValue,
    rawValue,
    key: `bundle:${bundleProductId}:${bundleInstanceId || rawValue}`,
  };
};

export const getMintsoftBundleProductIds = (items = []) =>
  Array.from(
    new Set(
      items
        .map((item) => getMintsoftBundleInfo(item)?.bundleProductId)
        .filter(Boolean)
    )
  );

export const buildMintsoftDisplayGroups = (items = []) => {
  const groups = [];
  const bundleGroupMap = new Map();

  items.forEach((item) => {
    const bundleInfo = getMintsoftBundleInfo(item);

    if (!bundleInfo) {
      groups.push({
        type: 'item',
        key: `item:${item.ID}`,
        items: [item],
        item,
      });
      return;
    }

    if (!bundleGroupMap.has(bundleInfo.key)) {
      const group = {
        type: 'bundle',
        key: bundleInfo.key,
        bundleInfo,
        items: [],
      };
      bundleGroupMap.set(bundleInfo.key, group);
      groups.push(group);
    }

    bundleGroupMap.get(bundleInfo.key).items.push(item);
  });

  return groups;
};

export const isMintsoftDisplayGroupConfirmed = (group, confirmedLineIds = []) =>
  group?.items?.length > 0 && group.items.every((item) => confirmedLineIds.includes(item.ID));
